var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('h1',{staticStyle:{"text-align":"left","margin-bottom":"20px"}},[_vm._v(_vm._s(_vm.$t('shortCourse')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }